export default "__VITE_ASSET__22MEjxue__"